import { render, staticRenderFns } from "./SMSTextingPolicy.vue?vue&type=template&id=56dd0147&scoped=true"
import script from "./SMSTextingPolicy.vue?vue&type=script&lang=js"
export * from "./SMSTextingPolicy.vue?vue&type=script&lang=js"
import style0 from "./SMSTextingPolicy.vue?vue&type=style&index=0&id=56dd0147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd0147",
  null
  
)

export default component.exports